// JsFromRoutes CacheKey 22599c5ec8145faed3e1facac5165cab
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/:account_id/conversations/:conversation_id/suggestions'),
}
